import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardPage from '../components/DashboardPage';

const Ownership = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Data Sheet',
      onClick: () => navigate('/ownership/data-sheet'),
      desc: 'Template to collect ownership data',
      icon: (
        <svg viewBox="0 0 24 24">
          <line x1="18" y1="20" x2="18" y2="10"/>
          <line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
      ),
    },
    {
      label: 'Ownership Scorecard',
      onClick: () => navigate('/ownership/scorecard'),
      desc: 'Total Points, Ownership Scorecard calculation',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
          <rect x="9" y="3" width="6" height="4" rx="1"/>
          <line x1="9" y1="12" x2="15" y2="12"/>
          <line x1="9" y1="16" x2="13" y2="16"/>
        </svg>
      ),
    },
    {
      label: 'Documentation',
      onClick: () => navigate('/ownership/documentation'),
      desc: 'Documentation Upload',
      icon: (
        <svg viewBox="0 0 24 24">
          <line x1="12" y1="1" x2="12" y2="23"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
    },
    {
      label: 'KPI Tracking and Reports',
      onClick: () => navigate('/ownership/reports'),
      desc: 'Regular tracking of ownership KPIs, with automated report generation',
      icon: (
        <svg viewBox="0 0 24 24">
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
          <polyline points="17 6 23 6 23 12"/>
        </svg>
      ),
    },
    {
      label: 'Templates & Resources',
      onClick: () => navigate('/ownership/templates-resources'),
      desc: 'Ownership-related templates, guides, and resources for Verification',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <line x1="19" y1="8" x2="19" y2="14"/>
          <line x1="22" y1="11" x2="16" y2="11"/>
        </svg>
      ),
    },
  ];

  return (
    <DashboardPage
      theme="ownership"
      title="Ownership"
      subtitle="B-BBEE Scorecard — Ownership Element"
      actions={actions}
    />
  );
};

export default Ownership;
